import { FC } from 'react';

import { Badge, BadgeProps } from 'antd';

import { ESourceRelationStatuses } from 'entities/Offer';
import { ESourceStatuses } from 'entities/Source/model/types';
import { useTrans } from 'shared/hooks';

interface ISourceStatusProps extends BadgeProps {
	sourceStatus: ESourceStatuses | ESourceRelationStatuses;
}

export const SourceStatus: FC<ISourceStatusProps> = ({ sourceStatus, ...props }) => {
	const { sourceStatuses, relationStatuses } = useTrans();
	const statuseMap: Record<ESourceStatuses | ESourceRelationStatuses, { status: BadgeProps['status']; text: string }> =
		{
			[ESourceStatuses.NEW]: {
				status: 'warning',
				text: sourceStatuses[ESourceStatuses.NEW],
			},
			[ESourceStatuses.ACTIVE]: {
				status: 'success',
				text: sourceStatuses[ESourceStatuses.ACTIVE],
			},
			[ESourceStatuses.ON_VERIFICATION]: {
				status: 'default',
				text: sourceStatuses[ESourceStatuses.ON_VERIFICATION],
			},
			[ESourceStatuses.ON_MODERATION]: {
				status: 'default',
				text: sourceStatuses[ESourceStatuses.ON_MODERATION],
			},
			[ESourceStatuses.REJECTED]: {
				status: 'error',
				text: sourceStatuses[ESourceStatuses.REJECTED],
			},
			[ESourceRelationStatuses.JOINED]: {
				status: 'success',
				text: relationStatuses[ESourceRelationStatuses.JOINED],
			},
			[ESourceRelationStatuses.NOT_JOINED]: {
				status: 'default',
				text: relationStatuses[ESourceRelationStatuses.NOT_JOINED],
			},
			[ESourceRelationStatuses.VERIFICATION]: {
				status: 'default',
				text: relationStatuses[ESourceRelationStatuses.VERIFICATION],
			},
			[ESourceRelationStatuses.DISABLED]: {
				status: 'error',
				text: relationStatuses[ESourceRelationStatuses.DISABLED],
			},
		};

	return (
		<Badge
			{...props}
			style={{ whiteSpace: 'nowrap' }}
			status={statuseMap[sourceStatus]?.status}
			text={statuseMap[sourceStatus]?.text}
		/>
	);
};
